import {Directive, ElementRef} from '@angular/core';

@Directive({
  selector: 'input, select, button, textarea',
  standalone: true
})
export class CommonWidgetDirective {
  private $element: JQuery<HTMLElement>;
  constructor(elRef: ElementRef) {
    this.$element = $(elRef.nativeElement);
  }

  ngAfterViewInit() {
    if (this.$element.hasClass('disable-all') ||  this.$element.closest('.disable-all').length) {
      this.$element.attr('disabled', 'true');
    }
  }

}
